export const translations = {
  es: {
    hero: {
      title: 'Asesoría, Formación y Consultoría en Inteligencia Artificial',
      description: 'En Lumi Labs te ayudamos a integrar la IA en tu negocio de manera efectiva. Descubre cómo podemos impulsar tu proyecto con nuestra experiencia en formación especializada y consultoría estratégica.',
      cta: 'Explorar Servicios'
    },
    nav: {
      services: 'Servicios',
      courses: 'Formación',
      materials: 'Material',
      contact: 'Contacto'
    },
    about: {
      title: 'Quiénes Somos',
      subtitle: 'Descubre el equipo detrás de Lumi Labs y nuestra pasión por hacer la Inteligencia Artificial accesible y práctica para todos.',
      mission: 'Misión',
      missionDesc: 'Democratizar el conocimiento de la IA y formar profesionales preparados para los retos del futuro',
      team: 'Equipo',
      teamDesc: 'Contamos con expertos en IA y docentes con amplia experiencia en el sector tecnológico',
      methodology: 'Metodología',
      methodologyDesc: 'Aprendizaje práctico y personalizado con proyectos reales y mentorías individuales'
    },
    services: {
      title: 'Nuestros Servicios',
      subtitle: 'Capacitación en Inteligencia Artificial para impulsar tu negocio y equipo',
      followUs: 'Síguenos en redes',
      cta: 'Quiero contar con vosotras',
      consulting: {
        title: 'Asesoría',
        description: 'Te guiamos en la implementación de soluciones de IA para optimizar tus procesos y potenciar tu negocio.'
      },
      outreach: {
        title: 'Divulgación',
        description: 'Compartimos conocimiento sobre IA a través de charlas, workshops y contenido especializado.'
      },
      training: {
        title: 'Formación',
        description: 'Programas especializados y cursos adaptados a las necesidades específicas de tu equipo.'
      },
      strategy: {
        title: 'Consultoría',
        description: 'Análisis estratégico y acompañamiento en la transformación digital de tu empresa con IA.'
      }
    },
    courses: {
      title: 'Formación',
      subtitle: 'Programas a medida para dominar las últimas tecnologías en IA',
      fundamentals: {
        title: 'Fundamentos de IA',
        description: 'Introducción completa a los conceptos básicos de la Inteligencia Artificial'
      },
      ml: {
        title: 'Machine Learning Aplicado',
        description: 'Aprende a implementar algoritmos de ML en casos reales'
      },
      development: {
        title: 'Desarrollo con IA',
        description: 'Integra IA en tus aplicaciones y servicios'
      },
      llm: {
        title: 'ChatGPT & LLMs',
        description: 'Domina el uso de modelos de lenguaje y chatbots'
      }
    },
    materials: {
      title: 'Material Educativo',
      subtitle: 'Echa un vistazo a nuestro contenido',
      viewAll: 'Acceder a todo el material',
      backToHome: 'Volver al inicio'
    },
    contact: {
      title: 'Contacto',
      subtitle: '¿Quieres contar con nosotras?',
      description: 'Si buscas asesoría, formación o consultoría en Inteligencia Artificial, estamos aquí para ayudarte. Cuéntanos tu proyecto y nos pondremos en contacto contigo.',
      form: {
        name: 'Nombre',
        email: 'Email',
        message: 'Mensaje',
        send: 'Enviar Mensaje',
        sending: 'Enviando...'
      }
    },
    promptGuide: {
      title: 'Guía de Prompting',
      subtitle: 'Descarga nuestra guía gratuita y aprende a escribir prompts efectivos',
      description: 'Aprende las mejores prácticas y técnicas para crear prompts que maximicen los resultados de la IA generativa.',
      form: {
        email: 'Email profesional',
        emailPlaceholder: 'nombre@empresa.com',
        terms: 'He leído y acepto la política de privacidad y el envío de comunicaciones',
        submit: 'Descargar Guía',
        sending: 'Enviando...'
      }
    },
    footer: {
      rights: 'Todos los derechos reservados.'
    }
  },
  en: {
    hero: {
      title: 'AI Consulting, Training, and Advisory Services',
      description: 'At Lumi Labs, we help you integrate AI into your business effectively. Discover how we can boost your project with our expertise in specialized training and strategic consulting.',
      cta: 'Explore Services'
    },
    nav: {
      services: 'Services',
      courses: 'Training',
      materials: 'Resources',
      contact: 'Contact'
    },
    about: {
      title: 'About Us',
      subtitle: 'Meet the team behind Lumi Labs and our passion for making Artificial Intelligence accessible and practical for everyone.',
      mission: 'Mission',
      missionDesc: 'Democratize AI knowledge and train professionals ready for future challenges',
      team: 'Team',
      teamDesc: 'We have AI experts and teachers with extensive experience in the technology sector',
      methodology: 'Methodology',
      methodologyDesc: 'Practical and personalized learning with real projects and individual mentoring'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Comprehensive AI solutions to boost your business and team',
      followUs: 'Follow us',
      cta: 'Work with us',
      consulting: {
        title: 'Advisory',
        description: 'We guide you in implementing AI solutions to optimize your processes and enhance your business.'
      },
      outreach: {
        title: 'Outreach',
        description: 'We share AI knowledge through talks, workshops, and specialized content.'
      },
      training: {
        title: 'Training',
        description: 'Specialized programs and courses tailored to your team\'s specific needs.'
      },
      strategy: {
        title: 'Consulting',
        description: 'Strategic analysis and support in your company\'s digital transformation with AI.'
      }
    },
    courses: {
      title: 'Training',
      subtitle: 'Specialized programs to master the latest AI technologies',
      fundamentals: {
        title: 'AI Fundamentals',
        description: 'Complete introduction to the basics of Artificial Intelligence'
      },
      ml: {
        title: 'Applied Machine Learning',
        description: 'Learn to implement ML algorithms in real cases'
      },
      development: {
        title: 'AI Development',
        description: 'Integrate AI into your applications and services'
      },
      llm: {
        title: 'ChatGPT & LLMs',
        description: 'Master the use of language models and chatbots'
      }
    },
    materials: {
      title: 'Educational Resources',
      subtitle: 'Check out our content',
      viewAll: 'Access all materials',
      backToHome: 'Back to home'
    },
    contact: {
      title: 'Contact',
      subtitle: 'Want to work with us?',
      description: 'If you\'re looking for AI consulting, training, or advisory services, we\'re here to help. Tell us about your project and we\'ll get in touch with you.',
      form: {
        name: 'Name',
        email: 'Email',
        message: 'Message',
        send: 'Send Message',
        sending: 'Sending...'
      }
    },
    promptGuide: {
      title: 'Prompting Guide',
      subtitle: 'Download our free guide and learn to write effective prompts',
      description: 'Learn the best practices and techniques for creating prompts that maximize generative AI results.',
      form: {
        email: 'Professional email',
        emailPlaceholder: 'name@company.com',
        terms: 'I have read and accept the privacy policy and communications',
        submit: 'Download Guide',
        sending: 'Sending...'
      }
    },
    footer: {
      rights: 'All rights reserved.'
    }
  }
};